
<template>
    <!-- 选择指定批阅人 functionCode 默认为 o2o_train_center -->
    <yxt-drawer :size="size" destroy-on-close append-to-body :visible.sync="visible">
      <yxt-user-selector
        ref="selector"
        :data="users"
        :limit="30"
        :tabs="tabs"
        :enableGroupCorp="!!groupOrgFlag"
        :dataPermissionCode="groupOrgFlag?groupDataPermissionCode:dataPermissionCode"
        :functionCode="groupOrgFlag?groupFunctionCode:functionCode"
      ></yxt-user-selector>
      <div slot="footer">
        <yxt-button plain @click="cancelUser">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" @click="getUsers">{{ $t('pc_ulcd_btn_done') }}</yxt-button>
      </div>
    </yxt-drawer>
</template>

<script>

export default {
  props: {
    users: {type: Array, default: []},
    visible: {type: Boolean, default: false},
    groupOrgFlag: { type: Number, default: 0 }, // 当前ULCD环境是否为集团版环境，0-否 1-是，默认为0，此值为方便业务组件拿到当前ULCD环境状态，具体是否使用到此值以任务应用方为准
    bizComponentConfig: { type: Object,
      default: () => {
        return {
        };
      }
    }
  },
  data() {
    return {
      size: '960px',
      tabs: ['persons', 'userGroup', 'advance'],
      functionCode: '',
      dataPermissionCode: '',
      groupDataPermissionCode: '',
      groupFunctionCode: ''
    };
  },
  computed: {
  },
  watch: {
    bizComponentConfig(nval) {
      let isObj = (val) => Object.prototype.toString.call(val) === '[object Object]';
      let getVal = (target) => isObj(target) ? (target['value'] || target['defVal']) : '';
      if (isObj(nval)) {
        const { functionCode, dataPermissionCode, groupFunctionCode, groupDataPermissionCode } = this.bizComponentConfig;
        if (this.groupOrgFlag === 1) {
          this.groupFunctionCode = getVal(groupFunctionCode);
          this.groupDataPermissionCode = getVal(groupDataPermissionCode);
        }
        this.functionCode = getVal(functionCode);
        this.dataPermissionCode = getVal(dataPermissionCode);
      }
    }
  },
  methods: {
    cancelUser() {
      this.$emit('update:visible', false);
    },
    getUsers() {
      this.$refs.selector.getSelected().then(res => {
        this.$emit('getUsers', res);
        this.cancelUser();
      }).catch(e => {
        console.error(e);
      });
    }

  }
};
</script>
